/**
 * Cloudflare Turnstile 配置文件
 * 
 * 使用方法：
 * 1. 直接在这里配置你的 Site Key
 * 2. 或者使用环境变量 VUE_APP_TURNSTILE_SITE_KEY
 */

export default {
    // Turnstile Site Key - 从 Cloudflare Dashboard 获取
    // 你可以直接在这里设置，或者使用环境变量
    siteKey: '0x4AAAAAAB8lYQJSCAI6WbG_',
    
    // 是否启用 Turnstile 验证
    enabled: 'true',
    
    // Turnstile 配置选项
    options: {
      // 主题: 'light', 'dark', 'auto'
      theme: 'light',
      
      // 大小: 'normal', 'compact'
      size: 'normal',
      
      // 语言: 'auto', 'zh-CN', 'en', 等
      language: 'auto',
      
      // Tab 键顺序
      tabindex: 0,
    },
    // 开发环境配置
    development: {
      // 是否在开发环境使用测试密钥
      useTestKey: false,
      
      // 是否显示调试信息
      debug: false,
    },
  };
  
  